import { Anchor, Box, Button, Group, Text } from '@mantine/core';
import { useConsent } from '../lib/consent/ConsentProvider';
import { COOKIE_POLICY_URL } from '../lib/externalLinks';
import { tokens } from '../theme';

// Gates Clarity + GA4 behind an explicit choice. Shown on first visit and again when reopened
// from the footer, where the copy states the current setting. Reject and Accept share one
// variant so neither is nudged (ICO equal prominence); vendors are named on the policy page.
export function ConsentBanner() {
  const { needsBanner, choice, accept, reject } = useConsent();
  if (!needsBanner) return null;

  let copy: string;
  if (choice === 'granted') {
    copy = 'Analytics cookies are currently on. We use them to understand how the Hub is used and to improve it.';
  } else if (choice === 'denied') {
    copy = "Analytics cookies are currently off. We'd like to use them to understand how the Hub is used and to improve it.";
  } else {
    copy = "We'd like to use cookies to understand how the Hub is used and to improve it. You can change your choice at any time.";
  }

  return (
    <Box
      component="section"
      aria-label="Cookies"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: tokens.navyDeep,
        borderTop: `1px solid ${tokens.navyBorder}`,
      }}
    >
      <Group
        justify="space-between"
        align="center"
        wrap="wrap"
        gap="md"
        px="lg"
        py="md"
        style={{ maxWidth: 1280, margin: '0 auto' }}
      >
        <Text size="sm" c={tokens.textMuted} style={{ maxWidth: 720 }}>
          {copy}{' '}
          <Anchor href={COOKIE_POLICY_URL} target="_blank" rel="noreferrer">
            Cookie policy
          </Anchor>
        </Text>
        <Group gap="sm">
          <Button size="sm" variant="default" onClick={reject}>Reject</Button>
          <Button size="sm" variant="default" onClick={accept}>Accept</Button>
        </Group>
      </Group>
    </Box>
  );
}
